import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=96bcd99c&"
import script from "./WysiwygEditor.vue?vue&type=script&lang=ts&"
export * from "./WysiwygEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WysiwygEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports